import { FaClipboardList, FaFileInvoice } from "react-icons/fa";
import Button from "../ui/Button";
import { useQuote } from "../../context/QuoteContext";
import { stripHtml } from "../../utils/richText";

export default function QuoteSidebar() {
  const { items, count } = useQuote();
  return (
    <aside className="sticky top-28 rounded-xl border border-line bg-white p-5 shadow-soft">
      <div className="flex items-center gap-3">
        <span className="grid h-11 w-11 place-items-center rounded-xl bg-emerald-50 text-primary"><FaClipboardList /></span>
        <div>
          <h3 className="text-lg font-semibold text-dark">Quote Summary</h3>
          <p className="text-sm text-slate-500">{count} selected item{count === 1 ? "" : "s"}</p>
        </div>
      </div>
      <div className="mt-5 grid gap-3">
        {items.slice(0, 5).map((item) => (
          <div key={item.quoteKey || item.id} className="flex items-center justify-between gap-3 rounded-xl bg-slate-50 px-3 py-2 text-sm">
            <span className="font-bold text-dark">
              {stripHtml(item.name)}
              {item.selectedVariant?.label ? (
                <small className="block font-semibold text-slate-500">{item.selectedVariant.label}</small>
              ) : null}
            </span>
            <span className="font-semibold text-primary">x{item.quantity}</span>
          </div>
        ))}
      </div>
      <Button to="/request-quote" className="mt-5 w-full"><FaFileInvoice /> Request Quote</Button>
      <p className="mt-4 text-sm leading-6 text-slate-500">No online payment. Our sales team will verify quantity, delivery, GST details and brand availability before quoting.</p>
    </aside>
  );
}
